module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0068.jpg?v=2c39393a";